var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('edit-frame',{attrs:{"width":"100%","isEditing":_vm.editMode,"hideControls":true}},[_c('v-text-field',{attrs:{"required":"","rules":[
      _vm.$validation.vuetify.single({
        numericality: {
          greaterThanOrEqualTo: 1,
          lessThanOrEqualTo: 1825,
        },
        presence: true,
      }),
    ],"suffix":"Tage","label":"Maximale Mietdauer","outlined":"","dense":"","disabled":!_vm.editMode},on:{"input":_vm.onInput},model:{value:(_vm.maxRentalDurationD),callback:function ($$v) {_vm.maxRentalDurationD=$$v},expression:"maxRentalDurationD"}}),_c('v-text-field',{attrs:{"required":"","rules":[
      _vm.$validation.vuetify.single({
        numericality: { greaterThanOrEqualTo: 0, lessThanOrEqualTo: 365 },
        presence: true,
      }),
    ],"suffix":"Tage","label":"Maximale Vorlaufzeit","outlined":"","dense":"","disabled":!_vm.editMode},on:{"input":_vm.onInput},model:{value:(_vm.maxPrebookDurationD),callback:function ($$v) {_vm.maxPrebookDurationD=$$v},expression:"maxPrebookDurationD"}}),_c('v-text-field',{attrs:{"disabled":!_vm.editMode && _vm.capacity <= 1,"rules":[
      _vm.$validation.vuetify.single({
        numericality: { greaterThanOrEqualTo: 0, lessThanOrEqualTo: 24 },
        presence: true,
      }),
    ],"suffix":"Stunden","label":"Karenzzeit","outlined":"","dense":""},on:{"input":_vm.onInput},model:{value:(_vm.minInterBookingDurationH),callback:function ($$v) {_vm.minInterBookingDurationH=$$v},expression:"minInterBookingDurationH"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }